import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

const ENDPOINT = '/iVCEBlast/';

function mapInputToPayload(data: ParsedValues): APIPayload {
  return {
    title: data.title,
    mass: data.mass,
    LHV: data.LHV,
    mf: data.mf,
    R: data.R,
    Confinement: data.Confinement,
    V: data.V,
    A: data.A
  };
}

const { analyze, analyzeCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>(ENDPOINT, mapInputToPayload, { retry: 2, timeout: 20000 });

export { analyze, analyzeCancellable };
